import { validaCpf } from "../../../Utils";
import yup from "../../../validation";

export default yup.object().shape({
  nome: yup.string().required().nullable(),
  sobrenome: yup.string().required().nullable(),
  cpf: yup
    .string()
    .required()
    .test("cpf", "CPF inválido", (value) => {
      if (value) {
        const valido = validaCpf(value);
        return valido;
      }
    }),
  /*.test("cpf", "CPF já cadastrado", async (value) => {
      if (value) {
        const unico = await unicCpf(value).then((resp) => {
          return resp.dados;
        });

        if (unico) {
          return false;
        }

        return true;
      }
    }),*/
  email: yup.string().email().required(),
  /*.test("email", "E-mail já cadastrado", async (value) => {
      const unico = await unicEmail(value).then((resp) => {
        return resp.dados;
      });

      if (unico) {
        return false;
      }

      return true;
    })*/ dataNasc: yup.date().required().nullable(),
  //sexo: yup.string().required(),
  //ddd_telefone: yup.number().required().positive().integer(),
  //telefone: yup.string().required(),
  dddCel: yup.number().required().positive().integer().nullable(),
  celular: yup.string().required().nullable(),
  endereco: yup.string().required().nullable(),
  numero: yup.string().required().nullable(),
  bairro: yup.string().required().nullable(),
  cidade: yup.string().required().nullable(),
  uf: yup.string().min(2).required().nullable(),
  cep: yup.string().required().nullable(),
  /* senha: yup.string().min(8).required(),
  confirmaSenha: yup
    .string()
    .oneOf([yup.ref("senha"), null], "Senha não confirmada"),*/
});
